import { render, staticRenderFns } from "./PapercleanArticoliListPage.vue?vue&type=template&id=50cceec3"
import script from "./PapercleanArticoliListPage.vue?vue&type=script&lang=js"
export * from "./PapercleanArticoliListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports